
export function isLoggedIn() {
    const editBar = document.querySelector('#edit-bar');
    const isLoggedIn = !!editBar;
    return isLoggedIn;
}

